export default "__VITE_ASSET__DIJAFfH0__"